<div class="modal-header">
    <h3 id="helpLabel">Feedback Form</h3>
    <button type="button" class="close" data-dismiss="modal"
            aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        ×
    </button>
</div>
<div class="modal-body">
    <iframe title="Feedback Form" src="https://pbs-cjoef.formstack.com/forms/pbs_learningmedia"></iframe>
</div>
